"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadImportFile = downloadImportFile;
const BaseClient_1 = require("@juvare/platform-sdk-js/BaseClient");
async function downloadImportFile(param) {
    if (BaseClient_1.baseClientDefaults.tokenProvider) {
        const jwt = await BaseClient_1.baseClientDefaults.tokenProvider.onTokenRequest();
        downloadFileUsingJwt(param, jwt);
    }
    else {
        window.open(getAttachmentUrl(param), '_blank');
    }
}
function downloadFileUsingJwt(param, jwt) {
    const form = document.createElement('form');
    form.method = 'post';
    form.target = '_blank';
    form.action = BaseClient_1.baseClientDefaults.baseUrl + '/api/v1/import/getResults';
    const inputs = [];
    inputs.push(`<input type="hidden" name="id" value="${param.id}">`);
    inputs.push(`<input type="hidden" name="jwt" value="${jwt}">`);
    if (param.downloadFileName) {
        inputs.push(`<input type="hidden" name="downloadFileName" value="${param.downloadFileName}">`);
    }
    form.innerHTML = inputs.join();
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
function getAttachmentUrl(param) {
    const baseUrl = BaseClient_1.baseClientDefaults.baseUrl;
    const id = encodeURIComponent(param.id);
    const downloadFileNameParam = param.downloadFileName ? '&downloadFileName=' + encodeURIComponent(param.downloadFileName) : '';
    return `${baseUrl}/api/v1/import/getResults?id=${id}${downloadFileNameParam}`;
}
